import { faCheck } from '@fortawesome/pro-light-svg-icons';
import { Component, Input, OnInit, ViewEncapsulation, ElementRef, Output, EventEmitter } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'app-select-list',
  templateUrl: './select-list.component.html',
  styleUrls: ['./select-list.component.scss'],
})
export class SelectlistComponent implements OnInit {

  selectedOptions: string[];
  selectedType: string;
  isBinary: boolean;

  icons = {
    check: faCheck
  }


  @Input() options: string[];
  @Input() allowMultiple: boolean;
  @Input() formCtrlName: any;
  @Input() formGrp: FormGroup;

  @Output() changed = new EventEmitter<string[]>();

  constructor(private el: ElementRef) { }

  ngOnInit() {
    this.setType();
    this.selectedOptions = [this.options[0]];
    if(this.selectedOptions) {
      this.setIntialFormValue();
      this.setFormValue();
    }
  }

  setType() {
    if ((this.el.nativeElement as HTMLElement).hasAttribute('grid')) {
      this.selectedType = 'grid-list';
    }

    if ((this.el.nativeElement as HTMLElement).hasAttribute('binary')) {
      this.isBinary = true;
    }
  }
  setFormValue() {
    if(this.formCtrlName && this.formGrp) {
      const selectedValue = this.allowMultiple ? this.selectedOptions : this.selectedOptions[0]
      this.formGrp.get(this.formCtrlName)?.setValue(selectedValue);
    }
  }
  setIntialFormValue() {
    if(this.formCtrlName && this.formGrp) {
      const value = this.formGrp.get(this.formCtrlName)?.value;      
      this.selectedOptions = [value]
    }
  }

  change(option: string) {
    if (this.allowMultiple) {
      let _index = this.selectedOptions.findIndex(x => x === option);
      if (_index > -1) {
        this.selectedOptions.splice(_index, 1);
      }
      else {
        this.selectedOptions.push(option);
      }
    }
    else {
      this.selectedOptions = [option];
    }
    this.setFormValue();
    this.changed.emit(this.selectedOptions);
  }

  checkActive(option: string) {
    return this.selectedOptions.findIndex(x => x === option) > -1;
  }

}
